(function () {
  'use strict';

  function init() {
    if (typeof gsap === 'undefined') return;

    const drawerEl = document.querySelector('header-drawer');
    if (!drawerEl) return;

    const panelEl = drawerEl.querySelector('#menu-drawer');
    const summaryEl = drawerEl.querySelector('summary.header__icon--menu');
    const preLayersEl = drawerEl.querySelector('.sm-prelayers-mobile');

    if (!preLayersEl || !panelEl || !summaryEl) return;

    const layers = Array.from(preLayersEl.querySelectorAll('.sm-prelayer-mobile'));
    const iconSwap = summaryEl.querySelector('.t-icon-swap');

    let openTl = null;
    let closeTl = null;
    let iconOpen = false;

    // Pre-layers start off-screen to the left (matching drawer slide direction)
    gsap.set(layers, { xPercent: -100 });

    const origOpen = drawerEl.openMenuDrawer.bind(drawerEl);
    const origClose = drawerEl.closeMenuDrawer.bind(drawerEl);

    drawerEl.openMenuDrawer = function (summaryElement) {
      origOpen(summaryElement);
      if (window.matchMedia('(max-width: 989px)').matches) onOpen();
    };

    drawerEl.closeMenuDrawer = function (event, elementToFocus) {
      origClose(event, elementToFocus);
      if (window.matchMedia('(max-width: 989px)').matches) onClose();
    };

    function onOpen() {
      if (iconOpen) return;
      iconOpen = true;

      closeTl && closeTl.kill();
      openTl && openTl.kill();
      preLayersEl.style.display = 'block';

      const itemEls = getMenuItems();
      gsap.set(itemEls, { yPercent: 140, rotate: 10, opacity: 1, transformOrigin: '50% 100%' });

      openTl = gsap.timeline();

      // Pre-layers cascade in from the left
      layers.forEach(function (layer, i) {
        openTl.fromTo(
          layer,
          { xPercent: -100 },
          { xPercent: 0, duration: 0.5, ease: 'power4.out' },
          i * 0.07
        );
      });

      // Menu items stagger in after drawer starts opening
      if (itemEls.length) {
        openTl.to(
          itemEls,
          {
            yPercent: 0,
            rotate: 0,
            duration: 1,
            ease: 'power4.out',
            stagger: { each: 0.08, from: 'start' }
          },
          0.18
        );
      }

      if (iconSwap) iconSwap.dataset.state = 'b';
    }

    function onClose() {
      if (!iconOpen) return;
      iconOpen = false;

      openTl && openTl.kill();

      closeTl = gsap.timeline();
      closeTl.to(layers, {
        xPercent: -100,
        duration: 0.32,
        ease: 'power3.in',
        stagger: { each: 0.05, from: 'end' },
        onComplete: function () { preLayersEl.style.display = 'none'; }
      });

      if (iconSwap) iconSwap.dataset.state = 'a';
    }

    function getMenuItems() {
      return Array.from(
        panelEl.querySelectorAll(
          '.menu-drawer__menu > li > .menu-drawer__menu-item,' +
            '.menu-drawer__menu > li > details > summary.menu-drawer__menu-item'
        )
      );
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
